<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/Welcome' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>外贸门店列表</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 卡片 -->
    <el-card class="box-card" style="margin-top:20px">
      <!-- 搜索  新增-->
      <el-form
          size="mini"
          :inline="true"
          :model="searchForm"
          :rules="searchRules"
          ref="searchForRef"
          label-width="100px"
          autocomplete="on"
      >
        <el-form-item>
          <el-input v-model="searchForm.name" placeholder="所属省份" clearable type="text"></el-input>
        </el-form-item>
        <el-form-item>
          <el-input v-model="searchForm.name" placeholder="店铺名称" clearable type="text"></el-input>
        </el-form-item>
        <el-form-item>
          <el-input v-model="searchForm.name" placeholder="编号" clearable type="text"></el-input>
        </el-form-item>
        <el-form-item>
          <el-input v-model="searchForm.name" placeholder="类型" clearable type="text"></el-input>
        </el-form-item>
        <el-form-item>
          <el-select
              v-model="searchForm.grade_id"
              style="width: 180px;"
              placeholder="请选择类别"
          >
            <el-option
                v-for="item in gradeList"
                :key="item.id"
                :label="item.name"
                :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="success" size="mini" @click="searchSubmit()">搜索</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" size="mini" @click="addData">新增</el-button>
        </el-form-item>
      </el-form>

      <!-- 表格 -->
      <el-table
          ref="multipleTable"
          :data="tableLoadData"
          size="mini"
          border
          row-key="id"
          :tree-props="{children: 'children', hasChildren: 'hasChildren'}"
      >
        <el-table-column :index="indexMethod" type="index" label="序号" width="50"></el-table-column>
        <el-table-column
            label="名称"
            width="200"
            :show-overflow-tooltip='true'
        >
          <template slot-scope="scope">
            <span>{{scope.row.name}}</span>
          </template>
        </el-table-column>
        <el-table-column
            label="编码"
            width="100"
            :show-overflow-tooltip='true'
        >
          <template slot-scope="scope">
            <span>{{scope.row.sn}}</span>
          </template>
        </el-table-column>
        <el-table-column
            label="分类"
            width="100"
            :show-overflow-tooltip='true'
        >
          <template slot-scope="scope">
            <span>{{scope.row.category?scope.row.category.name:''}}</span>
          </template>
        </el-table-column>
        <el-table-column
            label="联系人"
            width="100"
            :show-overflow-tooltip='true'
        >
          <template slot-scope="scope">
            <span>{{scope.row.cont_name}}</span>
          </template>
        </el-table-column>
        <el-table-column
            label="联系电话"
            width="100"
            :show-overflow-tooltip='true'
        >
          <template slot-scope="scope">
            <span>{{scope.row.telephone}}</span>
          </template>
        </el-table-column>
        <el-table-column
            label="所属区域"
            width="100"
            :show-overflow-tooltip='true'
        >
          <template slot-scope="scope">
            <span>{{scope.row.province?scope.row.province.region_name:''}}</span>
            <span>{{scope.row.city?scope.row.city.region_name:''}}</span>
            <span>{{scope.row.district?scope.row.district.region_name:''}}</span>
          </template>
        </el-table-column>
        <el-table-column
            label="地址"
            :show-overflow-tooltip='true'
        >
          <template slot-scope="scope">
            <span>{{ scope.row.address }}</span>
          </template>
        </el-table-column>
        <el-table-column
            label="审核状态"
            :show-overflow-tooltip='true'
        >
          <template slot-scope="scope">
            <span style="color:#ff0000">{{ scope.row.is_auth==0?'待审核':'' }}</span>
            <span style="color: #5daf34">{{ scope.row.is_auth==1?'已审核':'' }}</span>
            <span style="color: #E6A23C">{{ scope.row.is_auth==2?'驳回':'' }}</span>
          </template>
        </el-table-column>
        <el-table-column
            fixed="right"
            label="操作"
            width="180">
          <template slot-scope="scope">
            <el-dropdown size="mini" split-button trigger="click">
              更多操作
              <el-dropdown-menu trigger="click">
                <el-dropdown-item @click.native="goAuth(scope.row)">审核</el-dropdown-item>
                <el-dropdown-item @click.native="goInfo(scope.row)">查看</el-dropdown-item>
                <el-dropdown-item @click.native="goEdit(scope.row)">修改</el-dropdown-item>
                <el-dropdown-item @click.native="openFileListDialog(scope.row)">查看资料</el-dropdown-item>
                <el-dropdown-item @click.native="openFileAddDialog(scope.row)">添加资料</el-dropdown-item>
                <el-dropdown-item @click.native="goFollow(scope.row)">跟进</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <div class="block" style="margin-top:10px">
        <el-pagination
            background
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="pageNum"
            :page-sizes="[10, 20, 30, 100]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total">
        </el-pagination>
      </div>
    </el-card>

    <!-- 新增编辑弹框（审核） -->
    <el-dialog :title="title" :visible.sync="dialogFormVisible" width="550px">
      <el-form :model="form" :rules="rules" ref="form" size="mini" label-width="80px">
        <el-form-item label="名称" prop="name">
          <el-input v-model="form.name" :readonly="true" autocomplete="off" placeholder="请输入名称"></el-input>
        </el-form-item>
        <el-form-item label="审核状态">
          <el-select
              v-model="form.is_auth"
              style="width: 180px;"
              placeholder="请选择审核状态"
          >
            <el-option
                v-for="item in authList"
                :key="item.id"
                :label="item.name"
                :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="mini" @click="reset_dialogForm('form')">取 消</el-button>
        <el-button size="mini" type="primary" @click="submitForm('form')">确 定</el-button>
      </div>
    </el-dialog>

    <!-- 资料列表组件（保留原有） -->
    <eFileList
        :formData="formData1"
        :visible="visible1"
        :title="title1"
        :closeForm="closeForm1"
    />

    <!-- 新增：资料添加弹框 -->
    <el-dialog
        title="添加门店资料"
        :visible.sync="fileDialogVisible"
        width="600px"
        @close="resetFileForm"
    >
      <el-form
          ref="fileFormRef"
          :model="fileForm"
          :rules="fileRules"
          size="mini"
          label-width="100px"
      >
        <!-- 资料名称 -->
        <el-form-item label="资料名称" prop="fileName">
          <el-input
              v-model="fileForm.fileName"
              placeholder="请输入资料名称（如：营业执照、租赁合同）"
              clearable
          ></el-input>
        </el-form-item>
        <!-- 资料分类 -->
        <el-form-item label="资料分类" prop="fileCateId">
          <el-select
              v-model="fileForm.fileCateId"
              placeholder="请选择资料分类"
              style="width: 100%;"
          >
            <el-option
                v-for="item in fileCategoryList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <!-- 文件上传 -->
        <el-form-item label="文件上传" prop="fileUrl">
          <el-upload
              ref="fileUploadRef"
              :action="uploadApi"
              :headers="uploadHeaders"
              :file-list="fileList"
              :on-success="handleFileUploadSuccess"
              :on-error="handleFileUploadError"
              :before-upload="beforeFileUpload"
              :limit="1"
              accept=".jpg,.png,.pdf,.doc,.docx,.xls,.xlsx"
              drag
          >
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">
              拖拽文件到此处，或<em>点击上传</em>
            </div>
            <div class="el-upload__tip" slot="tip">
              支持格式：jpg/png/pdf/doc/docx/xls/xlsx，单文件最大50MB
            </div>
          </el-upload>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <!-- 关闭按钮 -->
        <el-button size="mini" @click="fileDialogVisible = false">取 消</el-button>
        <!-- 保存按钮 -->
        <el-button size="mini" type="primary" @click="submitFileForm">保 存</el-button>
      </div>
    </el-dialog>

    <!-- 新增：查看门店资料列表弹框 -->
    <el-dialog
        title="门店资料列表"
        :visible.sync="fileListDialogVisible"
        width="800px"
        @close="resetFileList"
    >
      <!-- 资料列表表格 -->
      <el-table
          :data="shopFileList"
          size="mini"
          border
          stripe
          :loading="fileListLoading"
          style="width: 100%;"
      >
        <el-table-column type="index" label="序号" width="60"></el-table-column>
        <el-table-column
            label="资料名称"
            prop="file_name"
            min-width="200"
            :show-overflow-tooltip="true"
        ></el-table-column>
        <el-table-column
            label="资料分类"
            prop="cate_name"
            width="120"
            :show-overflow-tooltip="true"
        ></el-table-column>
        <el-table-column
            label="上传时间"
            prop="create_time"
            width="180"
            :show-overflow-tooltip="true"
            :formatter="formatFileTime"
        ></el-table-column>
        <el-table-column
            label="操作"
            width="160"
            fixed="right"
        >
          <template slot-scope="scope">
            <el-button
                size="mini"
                type="text"
                icon="el-icon-download"
                @click="downloadFile(scope.row)"
                v-if="scope.row.file_url"
            >下载</el-button>
            <el-button
                size="mini"
                type="text"
                icon="el-icon-delete"
                @click="deleteFile(scope.row)"
                style="color: #f56c6c;"
            >删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 无数据提示 -->
      <div v-if="!fileListLoading && shopFileList.length === 0" class="empty-file-list">
        <el-empty description="暂无门店资料"></el-empty>
      </div>
      <!-- 弹框底部 -->
      <div slot="footer" class="dialog-footer">
        <el-button size="mini" @click="fileListDialogVisible = false">关 闭</el-button>
        <el-button
            size="mini"
            type="primary"
            @click="refreshFileList"
            icon="el-icon-refresh"
        >刷 新</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import eFileList from "./components/eFileList.vue";
import moment from 'moment'     //日期时间转换

export default {
  name: "shopForeignList",
  components: {
    eFileList
  },
  props: {},
  data() {
    return {
      authList: [{ id: 0, name: '待审核' }, { id: 1, name: '已审核' }, { id: 2, name: '上级驳回' }],
      formData1: {},
      visible1: false,
      title1: '',

      gradeList: [],
      // 搜索
      searchForm: {
        name: "",
      },
      searchRules: {
        name: [
          { required: true, message: "请输入文章标题", trigger: "blur" }
        ],
      },
      // 数据
      tableLoadData: [],
      pageNum: 1,// 当前页码
      pageSize: 10,// 每页大小
      total: 0,//总条目数

      showType: '',
      roleList: [],

      rules: {
        name: [
          { required: true, message: '请输入名称', trigger: 'blur' },
          { min: 3, max: 15, message: "长度在 3 到 15 个字符", trigger: "blur" }
        ]
      },

      dialogFormVisible: false,
      title: '',
      form: {
        name: '',
        id: '',
        is_auth: '',
      },

      // ===== 资料添加相关 =====
      fileDialogVisible: false, // 资料添加弹框显示状态
      fileForm: {
        shopId: '', // 关联门店ID
        fileName: '', // 资料名称
        fileCateId: '', // 资料分类ID
        fileUrl: '' // 上传后的文件地址
      },
      fileRules: { // 资料表单验证规则
        fileName: [
          { required: true, message: '请输入资料名称', trigger: 'blur' },
          { min: 2, max: 50, message: '名称长度在2-50个字符之间', trigger: 'blur' }
        ],
        fileCateId: [
          { required: true, message: '请选择资料分类', trigger: 'change' }
        ],
        fileUrl: [
          { required: true, message: '请上传文件', trigger: 'change' }
        ]
      },
      fileCategoryList: [ // 资料分类列表（可从后端接口获取）
        { id: 1, name: '营业执照' },
        { id: 2, name: '租赁合同' },
        { id: 3, name: '法人身份证' },
        { id: 4, name: '门店照片' },
        { id: 5, name: '其他资料' }
      ],
      fileList: [], // 上传文件列表
      uploadApi: `${process.env.VUE_APP_BASE_API}/upload/file`, // 文件上传接口（替换为实际接口）
      uploadHeaders: { // 上传请求头（携带token）
        'Authorization': sessionStorage.getItem('token'),
        'company-id': sessionStorage.getItem('company_id')
      },

      // ===== 查看资料列表相关 =====
      fileListDialogVisible: false, // 资料列表弹框显示状态
      shopFileList: [], // 门店资料列表
      fileListLoading: false, // 资料列表加载状态
      currentShopId: '' // 当前查看的门店ID
    };
  },
  created() {
    this.DataList()
    this.departData()
    // 可选：加载资料分类列表（从后端获取）
    // this.getFileCategoryList()
  },
  mounted() {
  },
  filters: {
    //时间格式化
    dateFormat(add_time) {
      if (add_time == undefined) {
        return "";
      }
      return moment(add_time * 1000).format("YYYY-MM-DD HH:mm:ss");
    },
    statusFilter(status) {
      if (status == 0) {
        return "待审核";
      } else if (status == 1) {
        return "已审核";
      } else if (status == 2) {
        return "已出单";
      } else if (status == 3) {
        return "已完成";
      } else if (status == 4) {
        return "取保";
      } else if (status == 5) {
        return "退单";
      }
    }
  },
  methods: {
    goAuth(row) {
      this.form.id = row.id;
      this.form.name = row.name;
      this.form.is_auth = row.is_auth;
      this.dialogFormVisible = true;
    },

    // ===== 资料添加相关 =====
    openFileAddDialog(row) {
      // 初始化表单
      this.fileForm = {
        shopId: row.id,
        fileName: '',
        fileCateId: '',
        fileUrl: ''
      };
      this.fileList = []; // 清空文件列表
      this.fileDialogVisible = true; // 显示弹框
    },

    // ===== 新增：查看资料列表相关 =====
    // 打开资料列表弹框
    openFileListDialog(row) {
      this.currentShopId = row.id; // 记录当前门店ID
      this.fileListDialogVisible = true; // 显示弹框
      this.getShopFileList(); // 加载门店资料列表
    },
    // 获取门店资料列表
    getShopFileList() {
      this.fileListLoading = true;
      const param = {
        shop_id: this.currentShopId,
        company_id: sessionStorage.getItem('company_id'),
        access_token: sessionStorage.getItem('token'),
      };
      this.$axios.getShopFileList(param).then(res => {
        this.fileListLoading = false;
        if (res.code == 200) {
          this.shopFileList = res.data.data || [];
        } else {
          this.$message.error('获取资料列表失败：' + res.msg);
          this.shopFileList = [];
        }
      }).catch(error => {
        this.fileListLoading = false;
        console.log('获取门店资料列表失败：', error);
        this.$message.error('获取资料列表失败，请重试');
        this.shopFileList = [];
      });
    },
    // 刷新资料列表
    refreshFileList() {
      this.getShopFileList();
      this.$message.success('列表已刷新');
    },
    // 格式化文件上传时间
    formatFileTime(row) {
      if (!row.create_time) return '-';
      // 根据后端返回的时间格式调整（秒级/毫秒级）
      return moment(row.create_time).format("YYYY-MM-DD HH:mm:ss");
    },
    // 下载文件
    downloadFile(row) {
      if (!row.file_url) {
        this.$message.warning('文件地址不存在，无法下载');
        return;
      }
      try {
        // 方式1：直接下载（适用于可直接访问的文件地址）
        const link = document.createElement('a');
        link.href = row.file_url;
        link.download = row.file_name || '门店资料'; // 下载文件名
        link.target = '_blank';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        this.$message.success('开始下载文件');
      } catch (error) {
        // 方式2：调用后端下载接口（适用于需要权限的文件）
        // this.$axios.downloadFile({
        //   url: `${process.env.VUE_APP_BASE_API}/file/download`,
        //   method: 'get',
        //   params: { file_id: row.id },
        //   responseType: 'blob'
        // }).then(res => {
        //   // 处理blob文件下载
        //   const blob = new Blob([res.data]);
        //   const link = document.createElement('a');
        //   link.href = URL.createObjectURL(blob);
        //   link.download = row.file_name || '门店资料';
        //   link.click();
        //   URL.revokeObjectURL(link.href);
        // });
        console.log('文件下载失败：', error);
        this.$message.error('文件下载失败，请重试');
      }
    },
    // 删除文件
    deleteFile(row) {
      this.$confirm('确定要删除该资料吗？删除后不可恢复！', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const param = {
          id: row.id,
          shop_id: this.currentShopId,
          company_id: sessionStorage.getItem('company_id'),
          access_token: sessionStorage.getItem('token'),
        };
        this.$axios.deleteShopFile(param).then(res => {
          if (res.code == 200) {
            this.$message.success('资料删除成功');
            this.getShopFileList(); // 刷新列表
          } else {
            this.$message.error('资料删除失败：' + res.msg);
          }
        }).catch(error => {
          console.log('删除资料失败：', error);
          this.$message.error('资料删除失败，请重试');
        });
      }).catch(() => {
        this.$message.info('已取消删除');
      });
    },
    // 重置资料列表状态
    resetFileList() {
      this.shopFileList = [];
      this.currentShopId = '';
      this.fileListLoading = false;
    },

    goFile(row) {
      this.visible1 = true;
      this.formData1.shop_id = row.id;
      this.title1 = "图片资料";
    },
    closeForm1() {
      this.title1 = "";
      this.visible1 = false;
    },
    goInfo(row) {
      this.$router.push({
        path: '/shopInfo',
        query: {
          id: row.id
        }
      })
    },
    goEdit(row) {
      this.$router.push({
        path: '/shopForm',
        query: {
          id: row.id
        }
      })
    },
    goCategory() {
      this.$router.push('/newsCategory')
    },
    indexMethod(index) {
      return (this.pageNum - 1) * this.pageSize + index + 1
    },
    DataList() {
      const param = {
        company_id: sessionStorage.getItem('company_id'),
        access_token: sessionStorage.getItem('token'),
        proxy_id: sessionStorage.getItem('proxy_id'),
        pageSize: this.pageSize,
        pageNum: this.pageNum
      }
      this.$axios.shopListP(param).then(res => {
        if (res.code == 200) {
          this.tableLoadData = res.data.data;
          this.total = res.data.total;
        }
      }).catch(error => {
        console.log(error);
      })
    },
    // 设置每页条数
    handleSizeChange(newSize) {
      this.pageSize = newSize
      this.DataList()
    },
    // 分页跳转
    handleCurrentChange(newPage) {
      this.pageNum = newPage
      this.DataList()
    },
    departData() {
      const param = {
        company_id: sessionStorage.getItem('company_id'),
        access_token: sessionStorage.getItem('token'),
      }
      this.$axios.findTree(param).then(res => {
        if (res.code == 200) {
          this.rightslist = res.data.data
        }
      }).catch(error => {
        console.log(error);
      })
    },
    // 新增
    addData() {
      this.$router.push({
        name: 'shopForm'
      })
    },
    handelEdit(index) {
      this.id = index.data.row.id
      this.title = '编辑'
      this.form = {
        name: this.name,
      }
      this.dialogFormVisible = true
      this.form = JSON.parse(JSON.stringify(index.data.row))
    },
    reset_dialogForm(formName) {
      this.dialogFormVisible = false
      this.$nextTick(() => {
        this.$refs[formName].resetFields()
      })
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.form.id) {
            const param = {
              id: this.form.id,
              is_auth: this.form.is_auth,
              company_id: sessionStorage.getItem('company_id'),
              access_token: sessionStorage.getItem('token'),
            }
            this.$axios.shopAuth(param).then(res => {
              if (res.code == 200) {
                this.DataList()
                this.$message.success(res.msg)
                this.dialogFormVisible = false
              } else {
                this.$message.error(res.msg);
              }
            })
          }
        }
      })
    },
    searchSubmit() {
      this.pageNum = 1;
      this.DataList();
    },
    handelDel(e) {
      console.log(e);
      this.$confirm('此操作将删除该分类, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const param = {
          operator_id: sessionStorage.getItem('user_id'),
          company_id: sessionStorage.getItem('company_id'),
          access_token: sessionStorage.getItem('token'),
          id: e.data.row.id,
        }
        this.$axios.insuranceCorpDel(param).then(res => {
          if (res.code == 200) {
            this.$message.success(res.msg);
            this.DataList()
          } else {
            this.$message.error(res.msg);
          }
        }).catch(error => {
          console.log(error);
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
        this.DataList()
      });
      this.teamDialog = false
    },

    // ===== 资料添加相关方法 =====
    // 可选：从后端获取资料分类列表
    getFileCategoryList() {
      const param = {
        company_id: sessionStorage.getItem('company_id'),
        access_token: sessionStorage.getItem('token'),
      }
      this.$axios.getFileCateList(param).then(res => {
        if (res.code == 200) {
          this.fileCategoryList = res.data.data;
        }
      }).catch(error => {
        console.log('获取资料分类失败：', error);
      })
    },
    // 文件上传前校验
    beforeFileUpload(file) {
      // 校验文件大小（50MB）
      const isLt50M = file.size / 1024 / 1024 < 50;
      if (!isLt50M) {
        this.$message.error('上传文件大小不能超过50MB!');
        return false;
      }
      return true;
    },
    // 文件上传成功回调
    handleFileUploadSuccess(res, file) {
      console.log(file)
      if (res.code == 200) {
        this.fileForm.fileUrl = res.data.fileUrl; // 保存文件地址
        this.$message.success('文件上传成功');
      } else {
        this.$message.error('文件上传失败：' + res.msg);
      }
    },
    // 文件上传失败回调
    handleFileUploadError(err) {
      console.log('文件上传失败：', err);
      this.$message.error('文件上传失败，请重试');
    },
    // 重置资料表单
    resetFileForm() {
      this.$refs.fileFormRef?.resetFields();
      this.fileList = [];
      this.fileForm.fileUrl = '';
    },
    // 提交资料表单
    submitFileForm() {
      this.$refs.fileFormRef.validate((valid) => {
        if (valid) {
          // 构造提交参数
          const param = {
            shop_id: this.fileForm.shopId,
            file_name: this.fileForm.fileName,
            file_cate_id: this.fileForm.fileCateId,
            file_url: this.fileForm.fileUrl,
            company_id: sessionStorage.getItem('company_id'),
            access_token: sessionStorage.getItem('token'),
          };
          // 调用保存资料接口
          this.$axios.saveShopFile(param).then(res => {
            if (res.code == 200) {
              this.$message.success('资料添加成功');
              this.fileDialogVisible = false; // 关闭弹框
              this.resetFileForm(); // 重置表单
              // 若当前打开了资料列表弹框，自动刷新
              if (this.fileListDialogVisible && this.currentShopId === this.fileForm.shopId) {
                this.getShopFileList();
              }
            } else {
              this.$message.error('资料添加失败：' + res.msg);
            }
          }).catch(error => {
            console.log('保存资料失败：', error);
            this.$message.error('资料添加失败，请重试');
          });
        } else {
          this.$message.warning('请完善表单信息');
          return false;
        }
      });
    },
    // 占位方法（原goFollow）
    goFollow(row) {
      console.log('跟进门店：', row);
      // 可补充跟进逻辑
    }
  }
};
</script>

<style scoped>
/* 优化上传组件样式 */
.el-upload {
  width: 100%;
}
.el-upload-dragger {
  width: 100%;
  height: 180px;
  line-height: 180px;
}
/* 弹框按钮间距 */
.dialog-footer {
  text-align: right;
}
.dialog-footer button {
  margin-left: 10px;
}
/* 无资料列表样式 */
.empty-file-list {
  padding: 40px 0;
  text-align: center;
}
</style>